module.exports = __webpack_public_path__ + "img/បាការ៉ាត់.6e8b9464.png";